import { AccountCircle } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  Card,
  ClickAwayListener,
  CssBaseline,
  Divider,
  FormControl,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Popper,
  Select,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import rs_logo from "../../assets/redshift-logo-final.svg";
import { logout, selectUser } from "../../redux/slices/userSlice";
import NavItems, { NavItem } from "./NavItems";
import navbarstyles from "./Navbar.module.css";
import Mawmnolicense from "../mawm/Mawmnolicense";
import { setContainerIdnull } from "../../redux/slices/dockercontid";

const Navbar = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [accountOpen, setAccountOpen] = useState(false); // State to control popper visibility
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const [productcode, setproductcode] = useState("MAO");
  const sideBarOpen = Boolean(anchorEl);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [menuState, setMenuState] = useState<{ [key: string]: boolean }>(
    NavItems.reduce(
      (acc, item) => ({
        ...acc,
        [item.label]: false,
      }),
      {}
    )
  );

  const toggleSubmenu = (itemName: string) => {
    setMenuState((prevState) => ({
      ...prevState,
      [itemName]: !prevState[itemName],
    }));
  };

  const navigate = useNavigate();

  function navigateToPage(route: string): void {
    navigate(route);
    handleClose();
  }

  const handleAccountClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAccountOpen((prevOpen) => !prevOpen); // Toggle the popper visibility
    setAnchorEl2(event.currentTarget); // Store the anchor element
  };
  // const handleChangePassword = () => {
  //   // navigate("/resetPassword");
  // };

  const handleSignOut = () => {
    dispatch(logout());
    dispatch(setContainerIdnull());
    navigate("/login");
    setAccountOpen(false);
  };

  const handleClickAway = () => {
    setAccountOpen(false);
  };

  return (
    <>
      <AppBar
        position="sticky"
        className={navbarstyles.appbarCss}
      >
        <Toolbar variant="dense">
          <Box className={navbarstyles.toolbarOuterBox}>
            <Box className={navbarstyles.toolbarInnerBox}>
              {user && (
                <IconButton
                  className={navbarstyles.menuIconButtonCss}
                  edge="start" //menu display starts from left corner
                  aria-label="menu"
                  id="icon"
                  onClick={(event) => handleClick(event)}
                >
                  <MenuIcon />
                </IconButton>
              )}
              <Typography
                variant="h6"
                sx={{ color: "#fe524a", cursor: "pointer" }}
                onClick={() => navigateToPage("/configure")}
              >
                RS Automator
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
              }}
            >
              {user && (
                <FormControl
                  sx={{
                    width: "fit-content",
                  }}
                >
                  <Select
                    required
                    size="small"
                    id="statuscode"
                    value={productcode}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                      "& .MuiSelect-root": {
                        alignSelf: "flex-start",
                      },
                    }}
                    onChange={(e) => {
                      setproductcode(e.target.value);
                    }}
                  >
                    {["MAO", "MAWM"].map((product) => (
                      <MenuItem
                        key={product}
                        value={product}
                      >
                        {product}
                      </MenuItem>
                    ))}
                  </Select>
                  {productcode === "MAWM" && (
                    <Mawmnolicense
                      productcode={productcode}
                      setproductcode={setproductcode}
                    />
                  )}
                </FormControl>
              )}
              <Box className={navbarstyles.navbarImageOuterBox}>
                <Typography
                  variant="h5"
                  component="div"
                >
                  <img
                    className={navbarstyles.rsLogoCss}
                    src={rs_logo}
                    alt="logo"
                  />
                </Typography>
                {user && (
                  <IconButton
                    edge="start"
                    onClick={handleAccountClick}
                    disableRipple={true}
                  >
                    <AccountCircle className={navbarstyles.accountCircleCss} />
                  </IconButton>
                )}
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <CssBaseline />
      <Menu
        className={navbarstyles.menuOpenCss}
        id="basic-menu"
        anchorEl={anchorEl}
        open={sideBarOpen}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          // Set the height to 100% of the viewport height
        }}
        sx={{
          marginTop: {
            xs: "2.5%", // Change these values according to your design
            md: "1.4%",
            lg: "1.5%",
          },
          marginLeft: "-16px", // Adjust the left margin as needed
          "& .MuiPaper-root": {
            minHeight: "90vh",
            borderTop: "none",
            borderRadius: 0,
            boxShadow:
              "0px 2px 2px -2px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)", // Remove the top box shadow
          },
        }}
      >
        <Box className={navbarstyles.menuListOuterBox}>
          <MenuList>
            <Typography
              variant="h5"
              component="div"
              className={navbarstyles.menuCloseIconCss}
            >
              <IconButton
                aria-label="close-dashboard"
                sx={{ zIndex: 1 }}
                onClick={handleClose}
                id="close-dashboard"
              >
                <CloseIcon />
              </IconButton>
            </Typography>
            <List>
              {NavItems.map((item) => (
                <div key={item.label}>
                  <ListItem
                    disablePadding
                    onClick={() => {
                      if ((item as NavItem).options) {
                        toggleSubmenu(item.label);
                      } else {
                        navigateToPage(`${item.route}`);
                      }
                    }}
                  >
                    <ListItemButton>
                      {(item as NavItem).options ? ( // Check if there are options
                        <ListItemIcon>
                          {menuState[item.label] ? ( // Check if the submenu is open
                            <KeyboardArrowDownIcon // Render the ExpandLessIcon when open
                              id="icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleSubmenu(item.label);
                              }}
                            />
                          ) : (
                            <KeyboardArrowRightIcon // Render the ExpandMoreIcon when closed
                              id="icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleSubmenu(item.label);
                              }}
                            />
                          )}
                        </ListItemIcon>
                      ) : null}
                      <ListItemText primary={item.label} />
                    </ListItemButton>
                  </ListItem>
                  {(item as NavItem).options && menuState[item.label] && (
                    <List>
                      {(item as NavItem).options?.map((option: any) => (
                        <ListItem
                          key={option.id}
                          disablePadding
                          onClick={() => navigateToPage(`${option.route}`)}
                          sx={{ paddingLeft: "55px" }}
                        >
                          <ListItemButton>
                            <ListItemText primary={option.label} />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  )}
                </div>
              ))}
            </List>
          </MenuList>
        </Box>
      </Menu>
      {user && (
        <Popper
          open={accountOpen}
          anchorEl={anchorEl2}
        >
          <ClickAwayListener onClickAway={handleClickAway}>
            <Card className={navbarstyles.popperCardCss}>
              <MenuList
                autoFocusItem={accountOpen}
                id="account-menu-list"
              >
                <MenuItem
                  onClick={handleClickAway}
                  dense
                  className={navbarstyles.popperMenuItemCss}
                >
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <Box
                      display={"flex"}
                      gap={1}
                      alignItems={"center"}
                      textOverflow={"ellipsis"}
                      overflow={"hidden"}
                    >
                      <AccountCircle />

                      <Tooltip
                        placement="top-start"
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, -10],
                                },
                              },
                            ],
                          },
                        }}
                        title={`${user.firstName} ${user.lastName}`}
                      >
                        <Box
                          textOverflow={"ellipsis"}
                          overflow={"hidden"}
                          width={"10em"}
                          whiteSpace={"nowrap"}
                        >
                          {user.firstName} {user.lastName}
                        </Box>
                      </Tooltip>
                    </Box>

                    <Box
                      display={"flex"}
                      ml={4}
                    >
                      ({user.username})
                    </Box>
                  </Box>
                </MenuItem>
                <Divider className={navbarstyles.popperDividerCss} />
                {/* <MenuItem
                  onClick={handleChangePassword}
                  dense
                  className="card"
                >
                  Change Password
                </MenuItem> */}
                {/* <Divider className={navbarstyles.popperDividerCss} /> */}
                <MenuItem
                  onClick={handleSignOut}
                  dense
                  className="card"
                >
                  Sign Out
                </MenuItem>
              </MenuList>
            </Card>
          </ClickAwayListener>
        </Popper>
      )}
    </>
  );
};

export default Navbar;
